
import { Component, Vue, Prop, InjectReactive, ProvideReactive, Watch } from "vue-property-decorator"
import { Area, TreeNode } from "@/types"
import SureViewIcon from "@/components/SureViewIcon.vue"

@Component({
	components: {
		treeNew: () => import("./TreeNew.vue"),
		"sv-icon": SureViewIcon
	}
})
export default class TreeNew extends Vue {
	@InjectReactive("treeVisibility") visibility!: { [key: string]: boolean }

	@Prop()
	item!: TreeNode<Area>;

	@Prop()
	setActiveItem!: (ItemId: string) => void;

	@Prop()
	itemSelected!: (item: any) => void;

	@Prop()
	addItem!: (item: any) => void;

	@Prop()
	activeItemId!: string;

	@Prop()
	topLevelOnly: boolean | undefined;

	@Prop()
	showAddNewButton: boolean | undefined;

	@Prop()
	displayNode: boolean | undefined;

	private displayingChildren: boolean = true;
	private renderSubTree: boolean = true;
	private topLevelOverride: boolean = false;
	private checkForMoreItemsToShowTimeout: NodeJS.Timeout | null = null;
	private maxItemsToDisplay: number = 100

	private get shouldRenderSubTree (): boolean {
		if (this.topLevelOnly && !this.topLevelOverride) {
			return false
		} else {
			return this.renderSubTree
		}
	}

	private selected (item: any) {
		this.itemSelected(item)
	}

	private add (item: any) {
		this.addItem(item)
	}

	public created (): void {
		if (this.topLevelOnly === true) {
			this.renderSubTree = false
			this.displayingChildren = false
		}
	}

	private toggleSubTreeRender (): void {
		this.topLevelOverride = true

		if (this.renderSubTree) {
			this.removeChildren()
		} else {
			this.renderChildren()
		}
	}

	public renderChildren (): void {
		this.renderSubTree = true
	}

	public removeChildren (): void {
		this.renderSubTree = false
	}

	public doNothing (): void {

	}

	@Watch("topLevelOnly")
	private overrideTopLevelOnly (): void {
		this.renderSubTree = !this.topLevelOnly
	}

	private get childAreasToRender (): TreeNode<any>[] | null {
		if (!this.item || !this.item.children) {
			return null
		}

		let childrenLength = this.item.children.length

		let lessChildrenThanMaxItemsToDisplay = childrenLength < this.maxItemsToDisplay
		if (lessChildrenThanMaxItemsToDisplay) {
			return this.item.children
		}

		let itemsToRender = this.item.children.slice(0, this.maxItemsToDisplay)
		return itemsToRender
	}

	private checkForMoreItemsToShow (): void {
		if (this.checkForMoreItemsToShowTimeout) {
			clearTimeout(this.checkForMoreItemsToShowTimeout)
		}

		this.checkForMoreItemsToShowTimeout = setTimeout(async () => {
			if (this.areThereMoreItemsToShow) {
				this.maxItemsToDisplay += 100
			}
		}, 200)
	}

	private get areThereMoreItemsToShow (): boolean {
		if (!this.item || !this.item.children) {
			return false
		}

		let numberOfChildrenThatCanBeShown = this.item.children.length
		return numberOfChildrenThatCanBeShown > this.maxItemsToDisplay
	}

	private get chevronIconClass (): string {
		if (this.item.children && this.item.children.length > 0)	{
			return this.shouldRenderSubTree ? "fas fa-chevron-down" : "fas fa-chevron-right"
		}
		return "fas fa-dash"
	}
}
